import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { DialogModule } from '@sb/library/dialog';
import { FormFieldModule } from '@sb/library/form-field';
import { LayoutModule } from '@sb/library/layout';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { MultiFactorAuthInputComponent } from './mfa-input/multi-factor-auth-mfa-input.component';
import { MultiFactorAuthSetupDrawerComponent } from './setup-mfa-drawer/multi-factor-auth-setup-mfa-drawer.component';

@NgModule({
    declarations: [
        MultiFactorAuthInputComponent,
        MultiFactorAuthSetupDrawerComponent,
    ],
    imports: [
        CommonModule,
        BaseModule,
        LayoutModule,
        DialogModule,
        FormFieldModule,
        ReactiveFormsModule,
        ButtonModule,
        SubmissionBarModule
    ],
    exports: [
        MultiFactorAuthSetupDrawerComponent,
        MultiFactorAuthInputComponent
    ]
})
export class MultiFactorAuthModule { }
